const handleMarkInput = (value, mark, studentIndex, markIndex, callback) => {
  if (value === '') {
    mark.value = null
    return
  }
  const nextRef = `input-${studentIndex + 1}-${markIndex}`
  if (value.length > 2) {
    mark.value = Number(value.toString().slice(0, 3))
    return callback(nextRef)
  }
  let newVal = value.toString().slice(0, 2)
  if (isNaN(Number(newVal))) {
    mark.value = value
    return
  }
  let numberValue = Number(newVal)
  if (numberValue === 10) {
    mark.value = 10
    return callback(nextRef)
  }
  if (numberValue > 10) {
    mark.value = numberValue / 10
    return callback(nextRef)
  }
}

export { handleMarkInput }
